import * as React from 'react';
import { css, StyleSheet } from 'aphrodite';
import { colors, combineStyles, media, mixins } from '@blend/consumer-components';

import BlendLogo from '../../../BlendLogo/BlendLogo';
import { horizontalPadding, mediumViewHorizontalPadding, smallViewTopPadding } from '../paneStyles';
import './rightPane.scss';

const topMinMargin = 120;
const footerSpace = 56;

const rightPaneHorizontalPadding = 30;
const rightPaneBottomPadding = 20;

const styles = StyleSheet.create({
  rightPane: {
    backgroundColor: colors.white,
    overflow: 'auto',
    [media.mediumView]: {
      height: '100vh',
      '-webkitOverflowScrolling': 'touch',
    },
  },

  rightPaneFooter: {
    ...mixins.padding(0, rightPaneHorizontalPadding, rightPaneBottomPadding, rightPaneHorizontalPadding),
    flexGrow: 1,
    textAlign: 'right',
    width: '100%',
  },
  // we want a min-margin of 120px and a max-margin of 25vh
  // the min-margin is enforced as the margin on the contentContainer and
  // marginTop is a variable size container up to (max-margin - min-margin)
  marginTop: {
    [media.mediumView]: {
      height: `calc(25vh - ${topMinMargin}px)`,
    },
  },
  contentContainer: combineStyles(mixins.padding(smallViewTopPadding, horizontalPadding), {
    [media.mediumView]: combineStyles(mixins.padding(0, mediumViewHorizontalPadding, '5%'), {
      marginTop: topMinMargin,
      minHeight: `calc(75vh - ${footerSpace}px)`,
    }),
  }),
});

interface RightPaneProps {
  top?: React.ReactFragment;
}

export default class RightPane extends React.Component<RightPaneProps, {}> {
  render() {
    const { children, top } = this.props;
    return (
      // tabIndex -1 to avoid Firefox focus on the rightPane when navigating using keyboard tab. scroll element
      // on Firefox is also tabable
      <div tabIndex={-1} className={`${css(styles.rightPane)} RightPane`}>
        <div className={css(styles.marginTop)} />
        {top}
        <div className={css(styles.contentContainer)}>{children}</div>
        <div className={`${css(styles.rightPaneFooter)} u-hideOnMobile`}>
          <span>
            <BlendLogo stackedColor="grey" format="stacked" />
          </span>
        </div>
      </div>
    );
  }
}
